/* eslint-disable no-undef */
/**
 * Create a ecommerce event item with data retrieved from all data-item-xxx in the HTML
 * element that triggers the event
 *
 * @param {*} data - This data is sent when events are triggered i.e gtm:removeFromCart
 * In loading events that dont need user interaction dataLayer is filled with rendered data
 * in gtm cartridge scripts
 * @returns {object}
 */
function gtmCreateEcommerceItem(data, screenName, carouselTitle) {
    const gtmPosition = data.itemIndex;
    const itemListID = $('body').find('.breadcrumbs-folder').toArray().map(el => el.textContent).join(' | ');
    var item = {};

    if (data.itemId) {
        item.item_id = data.itemId.toString().toLowerCase();
    }
    if (data.itemName) {
        item.item_name = data.itemName;
    }
    if (screenName) {
        item.item_list_name = screenName;
    }
    if (itemListID) {
        item.item_list_id = itemListID;
    }
    if (carouselTitle && carouselTitle.length > 0) {
        item.item_list_name = carouselTitle;
        item.item_list_id = 'carousel';
    }
    if (data.itemCategory) {
        item.item_category = data.itemCategory;
    }
    if (data.itemCategory2) {
        item.item_category2 = data.itemCategory2;
    }
    if (data.itemCategory3) {
        item.item_category3 = data.itemCategory3;
    }
    if (data.itemCategory4) {
        item.item_category4 = data.itemCategory4;
    }
    if (data.itemPrice) {
        item.price = data.itemPrice;
    }
    if (gtmPosition) {
        item.index = gtmPosition;
    }
    if (data.itemBundle) {
        item.item_bundle = data.itemBundle;
    } else {
        item.item_bundle = 'false';
    }

    if (data.promotionIds) {
        item.promotion_id = data.promotionIds;
    }
    if (data.promotionName) {
        item.promotion_name = data.promotionName;
    }

    if (data.itemBundle != 'false') {
        item.item_bundle_name = data.itemName;
    }
    item.quantity = 1;

    return item;
}

function preparePLPGtmData($target) {
    var $body = $('body');
    var screenName = $body
        .find('.breadcrumbs-folder')
        .toArray()
        .map((el) => el.textContent)
        .join(' | ');
    var customerNumber = $body.find('#customerGTMDetails').data('number') || null;
    var plpSortOrder = $body
        .find('#searchResultSelect')
        .find('option:selected')
        .text()
        .trim();
    var filterValue = '';
    var filterType = '';

    filterType = $target.parents('.refinement').data('display-name');
    filterValue = $target.is('span')
        ? $target.text().trim()
        : $target.find('span').first().text().trim();

    return {
        customerNumber: customerNumber,
        screen_name: screenName,
        plp_sort_order: plpSortOrder,
        plp_filter_results: $('.grid-footer').data('hit-count'),
        plp_filter_type: filterType,
        plp_filter_value: filterValue,
    };
}

// This events will be mostly used for those cases that require a more global scope
// gtmNormalizer is global and defined in global.isml
module.exports = {
    subscription: function () {
        // This was added after merge since ui is not rendered again after clicking on subscription
        // intervals so we needed to update add to cart button category 4 on clicking on tabs
        // This will work both for pdp and plp quickview
        $('body').on('click', '.js-sor-interval-pdp', function (_e, _data) {
            var intervalString =
                $(this).children('.number')[0].innerHTML +
                ' ' +
                $(this).children('.week')[0].innerHTML;
            $('body .add-to-cart').data('item-category4', intervalString);
        });
        $('body').on('click', '#OsfSorRefillProductYes', function (_e, _data) {
            var targetEl =
                $('body .js-sor-interval-pdp.active') ||
                $('body .js-sor-interval-pdp.js-sor-interval-default');
            var gtmSorDefaultIntervalOption = $('.gtmSorDefaultIntervalOption').val();
            var gtmSorDefaultPeriodicityOption = $(
                '.gtmSorDefaultPeriodicityOption'
            ).val();
            var intervalString =
                (targetEl.children('.number')[0]?.innerHTML ||
                    gtmSorDefaultIntervalOption) +
                ' ' +
                gtmSorDefaultPeriodicityOption;
            var wasOpen = $(this).attr('aria-expanded');
            if (wasOpen) $('body .add-to-cart').data('item-category4', undefined);
            else $('body .add-to-cart').data('item-category4', intervalString);
        });
    },
    selectItem: function () {
        $('body').on('click', '.product-tile', function () {
            if ($(this).parent().parent().data('swiper-slide-index') >= 0)
                $(this).data(
                    'item-index',
                    $(this).parent().parent().data('swiper-slide-index')
                );
            else $(this).data('item-index', $(this).parent().parent().index());
            var data = Object.assign({}, $(this).data());
            // if we are adding a bundle then we are going to use bundled products instead
            // since the SEO agency asked to add separate products instead of the unitary bundle info
            var bundledProducts = data.itemBundledProducts;
            var items = [];
            // if it is a regular bundle
            if (bundledProducts) {
                bundledProducts.forEach(function (item) {
                    items.push(
                        gtmNormalizer({
                            item_id: item.id,
                            item_name: item.productName,
                            item_brand: item.range,
                            item_category: item.gtm_product_type,
                            item_category2: item.type_age,
                            item_category3: item.tech_foodtype,
                            item_category4: data.itemCategory4,
                            item_category5: item.flavour.join(','),
                            item_variant: item.weight,
                            item_list_id:
                                (data.itemTileDomain || 'pdCarousel') + '_' + window.cachedDate,
                            item_list_name: data.itemTileDomain || 'pdCarousel',
                            price: item.price.sales.decimalPrice,
                            quantity: 1,
                            discount: 0,
                            index: data.itemIndex,
                        })
                    );
                });
            }
            // if not a regular bundle
            else {
                items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
            }
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'select_item',
                ecommerce: {
                    items: items,
                },
            });
        });
    },
    addToCart: function () {
        $('body').on('gtm:addToCart', function (_e, data) {
            var dataset = Object.assign({}, $(this).data());
            var interactionType = $('.pdp-container').length > 0 ? 'added_from_pdp' : 'added_from_modal';
            var screenName = $('.pdp-container').length > 0 ? 'pdp' : 'plp';
            var items = [];
            items.push(gtmCreateEcommerceItem(data));

            // pushing event to the datalayer
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'add_to_cart',
                click_path: 'increase_quantity',
                screen_name: screenName,
                screen_section: screenName,
                interaction_type: interactionType,
                product_id: dataset.itemId,
                product_name: dataset.itemName,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + Number(item.price), 0),
                    items: items,
                },
            });
        });
        $('body').on('click', '.add-to-cart', function () {
            var data = Object.assign({}, $(this).data());
            // if we are adding a bundle then we are going to use bundled products instead
            // since the SEO agency asked to add separate products instead of the unitary bundle info
            var items = [];
            var interactionType = $('.pdp-container').length > 0 ? 'added_from_pdp' : 'added_from_modal';
            var screenName = $('.pdp-container').length > 0 ? 'pdp' : 'plp';
            var isCarousel = data.tileDomain === 'recommendations' || sessionStorage.getItem(`gtmIsCarousel_${data.pid}`) === 'true';
            var carouselTitle = isCarousel ? $('.recommendations-title').text().trim() : '';
            if (data.tileDomain === 'recommendations') {
                screenName = 'cart_page';
            }
            if (!carouselTitle.length) {
                carouselTitle = sessionStorage.getItem(`gtmTitle_${data.pid}`);
            }
            items.push(gtmCreateEcommerceItem(data, screenName, carouselTitle));
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'add_to_cart',
                click_path: 'add_to_cart',
                screen_name: screenName,
                screen_section: screenName,
                interaction_type: interactionType,
                product_id: data.itemId,
                product_name: data.itemName,
                ecommerce: {
                    currency: 'GBP',
                    value: items.reduce((sum, item) => sum + Number(item.price), 0),
                    items: items,
                },
            });
        });
    },
    removeFromCart: function () {
        $('body').on('gtm:removeFromCart', function (e, data) {
            var bundledProducts = data.itemBundledProducts;
            var items = [];
            // if it is a regular bundle
            if (bundledProducts) {
                bundledProducts.forEach(function (item) {
                    items.push(
                        gtmNormalizer({
                            item_id: item.id,
                            item_name: item.productName,
                            item_brand: item.range,
                            item_category: item.gtm_product_type,
                            item_category2: item.type_age,
                            item_category3: item.tech_foodtype,
                            item_category4: data.itemCategory4,
                            item_category5: item.flavour.join(','),
                            item_variant: item.weight,
                            price: item.price.sales.decimalPrice,
                            quantity: item.quantity * data.savedQuantity,
                            discount: 0,
                        })
                    );
                });
            } else {
                data.itemBundledProducts = undefined;
                items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
            }
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'remove_from_cart',
                interaction_type: data.interaction_type,
                ecommerce: {
                    items: items,
                },
            });
        });
    },
    rewardPoints: function () {
        $('body').on('gtm:rewardPoints', function (e, data) {
            dataLayer.push({
                event: 'nm.ecommerce',
                'event name': 'rewardPoints',
                eventCategory: 'products',
                eventAction: 'reward points exchange',
                eventLabel: parseInt(data.rewardPoints, 10).toString(),
            });
        });
    },
    stockistFind: function () {
        $('body').on('gtm:stockistFind', function (e, data) {
            dataLayer.push({
                event: 'nm.event',
                'event name': 'stockist_find',
                eventCategory: 'stockist',
                eventAction: data.payload.postalCode,
                eventLabel: data.count,
            });
        });
    },
    stockistClick: function () {
        $('body').on('gtm:stockistClick', function (e, data) {
            dataLayer.push({
                event: 'nm.event',
                'event name': 'stockist_click',
                eventCategory: 'stockist',
                eventAction: 'click',
                eventLabel:
                    data.storeName ||
                    $('div[role="dialog"]').find('.store-details').data('address'),
            });
        });
    },
    stockistCall: function () {
        $('body').on('mousedown', '.storelocator-phone', function (_e, _data) {
            dataLayer.push({
                event: 'nm.event',
                'event name': 'stockist_call',
                eventCategory: 'stockist',
                eventAction: 'call',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    stockistVisit: function () {
        $('body').on('mousedown', '.online-store', function (_e, _data) {
            dataLayer.push({
                event: 'nm.event',
                'event name': 'stockist_visit',
                eventCategory: 'stockist',
                eventAction: 'visit',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    c2c: function () {
        $('body').on('gtm:c2c', function (_e, _data) {
            dataLayer.push({
                event: 'nm.event',
                'event name': 'c2c',
                eventCategory: 'Phonenumber',
                eventAction: 'click',
                eventLabel:
                    $(this).data('store-name') ||
                    $(this).closest('.store-details').data('address'),
            });
        });
    },
    carousel: function () {
        $(document).ready(function () {
            if ($('.carousel').length > 0) {
                var elements = $('.carousel')
                    .find('.product-tile')
                    .parent()
                    .parent()
                    .not('[data-outofinitview]');
                var items = [];

                for (var i = 0; i < elements.length; i++) {
                    var $elem = elements.eq(i);
                    var data = Object.assign({}, $elem.find('.product-tile').data());
                    var bundledProducts = data.itemBundledProducts;

                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_variant: item.weight,
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        '_' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    price: item.price.sales.decimalPrice,
                                    quantity: 1,
                                    discount: 0,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    } else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
                    }
                }
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'view_item_list',
                    ecommerce: {
                        items: items,
                    },
                });
            }
        });
        // send an event every time a new product is displayed in the carousel
        $('body').on(
            'click',
            '.carousel-control-prev, .carousel-control-next',
            function () {
                var $elem;
                if ($(this).hasClass('carousel-control-next')) {
                    $elem = $(this).parent().find('.carousel-item[tabindex=-1]');
                } else if ($(this).hasClass('carousel-control-prev')) {
                    var totalItems = $(this).parent().find('.carousel-item').length;
                    var activePos = $(this)
                        .parent()
                        .find('.carousel-item.active')
                        .data('position');
                    if (activePos === 0) {
                        $elem = $(this)
                            .parent()
                            .find(`.carousel-item[data-position='${totalItems - 1}']`);
                    } else {
                        $elem = $(this)
                            .parent()
                            .find(`.carousel-item[data-position='${activePos - 1}']`);
                    }
                }
                if ($elem.length > 0) {
                    var data = Object.assign({}, $elem.find('.product-tile').data());

                    var bundledProducts = data.itemBundledProducts;
                    var items = [];

                    // if it is a regular bundle
                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_variant: item.weight,
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        '_' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    price: item.price.sales.decimalPrice,
                                    quantity: 1,
                                    discount: 0,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    }
                    // if not a regular bundle
                    else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data)));
                    }
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            items: items,
                        },
                    });
                }
            }
        );
    },
    swiper: function () {
        // send an event every time a new product is displayed in the swiper
        $('body').on(
            'click',
            '.swiper-button-prev, .swiper-button-next',
            function () {
                var numElements = $(this)
                    .parent()
                    .parent()
                    .find('.swiper')
                    .attr('numberslides');
                var $elem;
                if ($(this).hasClass('swiper-button-next')) {
                    var activePos = $(this)
                        .parent()
                        .parent()
                        .find('.swiper-slide-active')
                        .index();
                    $elem = $(this)
                        .parent()
                        .parent()
                        .find('.swiper-slide')
                        .eq(activePos + (numElements - 1));
                } else if ($(this).hasClass('swiper-button-prev')) {
                    $elem = $(this).parent().parent().find('.swiper-slide-active');
                }
                if ($elem.length > 0) {
                    var data = Object.assign({}, $elem.find('.product-tile').data());

                    var bundledProducts = data.itemBundledProducts;
                    var items = [];

                    // if it is a regular bundle
                    if (bundledProducts) {
                        bundledProducts.forEach(function (item) {
                            items.push(
                                gtmNormalizer({
                                    item_id: item.id,
                                    item_name: item.productName,
                                    item_brand: item.range,
                                    item_category: item.gtm_product_type,
                                    item_category2: item.type_age,
                                    item_category3: item.tech_foodtype,
                                    item_category4: data.itemCategory4,
                                    item_category5: item.flavour.join(','),
                                    item_variant: item.weight,
                                    item_list_id:
                                        (data.itemTileDomain || 'pdCarousel') +
                                        '_' +
                                        window.cachedDate,
                                    item_list_name: data.itemTileDomain || 'pdCarousel',
                                    price: item.price.sales.decimalPrice,
                                    quantity: 1,
                                    discount: 0,
                                    index: data.itemIndex,
                                })
                            );
                        });
                    }
                    // if not a regular bundle
                    else {
                        items.push(gtmNormalizer(gtmCreateEcommerceItem(data, true)));
                    }
                    dataLayer.push({ ecommerce: null });
                    dataLayer.push({
                        event: 'view_item_list',
                        ecommerce: {
                            items: items,
                        },
                    });
                }
            }
        );
    },
    /**
   * Attaches a click event handler to elements with the class 'js-logout' to push logout event details to the dataLayer.
   * The event handler retrieves customer GTM details from the DOM and pushes them to the dataLayer if available.
   *
   * @event click - Triggers when an element with the class 'js-logout' is clicked.
   * @fires dataLayer#event:logout - Pushes a logout event to the dataLayer with customer details.
   *
   * @property {string} sscid - The customer session ID retrieved from the 'data-sscid' attribute of the '#customerGTMDetails' element.
   * @property {string} number - The customer number retrieved from the 'data-number' attribute of the '#customerGTMDetails' element.
   */
    logout: function () {
        $('.js-logout').on('click', function () {
            const $GTMDetails = $('#customerGTMDetails');

            if (!$GTMDetails.length) {
                return;
            }

            const sscid = $GTMDetails.attr('data-sscid');
            const number = $GTMDetails.attr('data-number');

            if (!sscid) {
                return;
            }

            dataLayer.push({
                event: 'logout',
                ID18: sscid,
                customer_number: number,
            });
        });
    },
    navigation: function () {
        $('body').on('click', '.gtm-navigation-links', function (e) {
            try {
                const currentTarget = $(e.currentTarget);
                const protocol = window.location.protocol;
                const domain = window.location.hostname;
                const footerParent = currentTarget.closest('.footer-element');
                const headerParent =
                    $(document).width() < 768
                        ? currentTarget
                            .closest('.mobile-nav')
                            .find('.nav-item.rotate-arrow-icon')
                        : currentTarget.closest('.nav-item');
                const isFooter = footerParent.length > 0;
                const isLevel2 = !isFooter
                    ? currentTarget.hasClass('dropdown-link')
                    : true;
                const linkText = currentTarget.text() || '';

                if (!isFooter) {
                    dataLayer.push({
                        event: 'navigation_click',
                        navigation: 'header',
                        link_url: protocol + '//' + domain + currentTarget.attr('href') || '',
                        link_text: linkText.trim(),
                        lvl1: isLevel2
                            ? isFooter
                                ? $(footerParent[0]).find('.title').text().trim()
                                : $(document).width() < 768
                                    ? headerParent.find('.mobile-nav-link').text().trim()
                                    : headerParent.find('.nav-link').text().trim()
                            : linkText.trim(),
                        lvl2: isLevel2 ? linkText.trim() : '',
                        lvl3: 'TBC',
                    });
                } else {
                    const $pageElement = $('body > .page');
                    let screenName = '';

                    if ($pageElement) {
                        const action = $pageElement.data('action') || '';

                        const screenNameMap = {
                            Account: 'My Account',
                            Login: 'Login page',
                            Cart: 'Cart page',
                            Page: 'Content page',
                            Home: 'Homepage',
                            Search: 'PLP',
                            Product: 'PDP',
                            Order: 'Order page',
                            Address: 'Addresses',
                            PaymentInstruments: 'Payment methods',
                            ContactUs: 'Contact-us page'
                        };

                        const key = Object.keys(screenNameMap).find(k => action.includes(k));
                        screenName = key ? screenNameMap[key] : '';

                        if (!screenName) {
                            if ($pageElement.hasClass('checkout-page')) {
                                screenName = 'Checkout';
                            } else {
                                screenName = 'Homepage';
                            }
                        }
                    }

                    dataLayer.push({
                        event: 'interaction',
                        click_path: linkText.trim(),
                        screen_name: screenName,
                        screen_section: 'footer'
                    });

                    dataLayer.push({
                        event: 'callback request started',
                        method: 'footer link'
                    });
                }
            } catch (e) {
                console.log(e);
            }
        });
    },
    /**
   * Handles the sign-in or registration event and pushes relevant data to the dataLayer for GTM (Google Tag Manager).
   *
   * This function checks for the presence of customer GTM details in the DOM, determines if the current action is a login or registration,
   * and then pushes the appropriate event data to the dataLayer.
   *
   * @returns {void}
   */
    signIn: function () {
        const $GTMDetails = $('#customerGTMDetails');

        if (!$GTMDetails.length) {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const isLogin = urlParams.get('registration') === 'false';
        const isRegistration = urlParams.get('registration') === 'submitted';
        const isCheckout = $('#checkout-main').length > 0;
        const isMagicLinkLogin = urlParams.get('emailLinkLogin') === 'true';

        if (!isLogin && !isRegistration) {
            return;
        }

        const method = $GTMDetails.attr('data-method');
        const sscid = $GTMDetails.attr('data-sscid');
        const number = $GTMDetails.attr('data-number');

        if (!method || !sscid || !number) {
            return;
        }

        const dataToPush = {
            event: isRegistration ? 'sign_up' : 'login',
            user_id: number,
            method: method, // The signup method used. Google or email etc
            journey: isCheckout ? 'checkout' : 'login',
            promotional_newsletter: $('#newsletterConfirm').is(':checked')
                ? 'true'
                : 'false'
        };

        if (isMagicLinkLogin) {
            dataToPush.method = 'magic_link';
        }

        dataLayer.push(dataToPush);
    },
    failedLogin: function () {
        const loginError = $('.not-found-page').attr('data-login-error');

        if (loginError && loginError.length > 0) {
            dataLayer.push({
                event: 'login_failure',
                method: 'Google Account',
                errorMessage: loginError,
            });
        }

        $('body').on('gtm:failedLogin', function (e, data) {
            dataLayer.push({
                event: 'login_failure',
                method: data.method,
                errorMessage: data.errorMessage,
            });
        });
    },
    landingPages: function () {
        $('body').on('gtm:recipeOverlay', function (e, data) {
            const dataToPush = {
                event: 'overlay',
                click_path: data.click_path,
                screen_name: 'recipes',
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            dataLayer.push(dataToPush);
        });

        $('body').on('gtm:clickCTA', function (e, data) {
            const dataToPush = {
                event: 'click_cta',
                click_path: data.click_path,
                screen_name: data.screen_name,
                screen_section: data.screen_section,
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            dataLayer.push(dataToPush);
        });
    },
    checkoutSteps: function () {
        $('body').on('gtm:checkoutStep', function (e, data) {
            const urlParams = new URLSearchParams(window.location.search);
            const isStageCustomer = urlParams.get('stage') === 'customer';
            const isHashCustomer = window.location.hash === '#customer';
            if (isStageCustomer && isHashCustomer) {
                const dataToPush = {
                    event: 'account_registration_login',
                };

                dataLayer.push(dataToPush);
            }
        });
    },
    statsigEvent: function () {
        $('body').on('gtm:statsigEvent', function (e, data) {
            const dataToPush = {
                event: 'experiment_viewed',
                experiment_name: data.experiment_name,
                variant_name: data.variant_name,
            };

            dataLayer.push(dataToPush);
        });
    },
    loginPage: function () {
        $('body').on('gtm:loginInteraction', function (e, data) {
            const dataToPush = {
                event: data.event,
                click_path: data.click_path,
                click_type: data.click_type,
                screen_name: 'login page',
            };

            if (data.journey) {
                dataToPush.journey = data.journey;
            }

            dataLayer.push(dataToPush);
        });
    },
    navbarClick: function () {
        var $body = $('body');

        $body.on('gtm:navbarClick', function (e, data) {
            var customerNumber =
                $body.find('#customerGTMDetails').data('number') || null;
            var params = {
                event: 'nav-bar_interaction',
                click_path: data.click_path,
                click_type: data.click_type,
            };

            if (customerNumber) {
                params['user_id'] = customerNumber;
            }

            dataLayer.push(params);
        });
    },
    plpApplyFilters: function () {
        $('body').on('gtm:plpApplyFilters', function (e, params) {
            const data = preparePLPGtmData(params.target);
            const dataToPush = {
                event: 'plp_apply_filter',
                journey: 'ecommerce',
                screen_name: data.screen_name,
                screen_section: 'plp',
                plp_sort_order: data.plp_sort_order,
                plp_filter_type: data.plp_filter_type,
                plp_filter_value: data.plp_filter_value,
                plp_filter_results: data.plp_filter_results,
            };

            if (data.customerNumber) {
                dataToPush['user_id'] = data.customerNumber;
            }

            dataLayer.push(dataToPush);
        });
    },
    plpChangeSortOrder: function () {
        $('body').on('gtm:plpSort', function (e, data) {
            var customerNumber = $('body').find('#customerGTMDetails').data('number') || null;
            var screenName = $('body').find('.breadcrumbs-folder').toArray().map((el) => el.textContent).join(' | ');
            const dataToPush = {
                event: 'plp_change_sort_order',
                journey: 'ecommerce',
                plp_sort_order: data.selectedValue,
                screen_section: 'plp',
                screen_name: screenName,
            };

            if (customerNumber) {
                dataToPush.user_id = customerNumber;
            }

            dataLayer.push(dataToPush);
        });
    },
    trackTrustpilotClick: function () {
        // Function to setup overlay
        function setupTrustpilotOverlay() {
            if ($('.trustpilot-widget').length === 0) {
                console.log('Trustpilot widget not found, retrying...');
                setTimeout(setupTrustpilotOverlay, 1000);
                return;
            }

            $('.trustpilot-widget').css('position', 'relative');
            $('.trustpilot-click-overlay').remove();
            $('.trustpilot-widget').append('<div class="trustpilot-click-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; background: transparent; cursor: pointer;"></div>');
            $('.trustpilot-click-overlay').on('click', function (e) {
                var customerNumber = $('body').find('#homepage').data('customer') || null;
                var dataToPush = {
                    event: 'interaction',
                    click_type: 'banner',
                    click_path: 'trustpilot',
                    screen_name: 'homepage',
                };
                if (customerNumber) {
                    dataToPush.user_id = customerNumber;
                }

                console.log('Sending GTM data:', dataToPush);
                dataLayer.push(dataToPush);
                window.open('https://uk.trustpilot.com/review/www.naturesmenu.co.uk', '_blank');
            });
        }
        setupTrustpilotOverlay();
        $(document).on('DOMNodeInserted', function (e) {
            if ($(e.target).find('.trustpilot-widget').length > 0 || $(e.target).hasClass('trustpilot-widget')) {
                console.log('Trustpilot widget added to DOM, setting up overlay');
                setTimeout(setupTrustpilotOverlay, 100);
            }
        });
    },
    trackRequestACallbackClick: function () {
        $('.header-banner .calendly-link').on('click', function () {
            const $pageElement = $('body > .page');
            let screenName = '';

            if ($pageElement) {
                const action = $pageElement.data('action') || '';

                const screenNameMap = {
                    Account: 'My Account',
                    Login: 'Login page',
                    Cart: 'Cart page',
                    Page: 'Content Page',
                    Home: 'Homepage',
                    Search: 'PLP',
                    Product: 'PDP',
                    Order: 'Order page',
                    Address: 'Addresses',
                    PaymentInstruments: 'Payment methods',
                    ContactUs: 'Contact-us page'
                };

                const key = Object.keys(screenNameMap).find(k => action.includes(k));
                screenName = key ? screenNameMap[key] : '';

                if (!screenName) {
                    if ($pageElement.hasClass('checkout-page')) {
                        screenName = 'Checkout';
                    } else {
                        screenName = 'Homepage';
                    }
                }
            }

            dataLayer.push({
                event: 'interaction',
                click_path: 'request a call back',
                screen_name: screenName,
                screen_section: 'sticky banner',
                gtm_uniqueEventId: '000'
            });

            dataLayer.push({
                event: 'callback request started',
                method: 'sticky banner'
            });
        })
    }
};
